export const visibilityTimeUntilRedirect = 20;



// WEBPACK FOOTER //
// ./components/partial/layers/modals/errorBlockTransactionModal/constant.js